import React, { useState, useEffect } from 'react'
import { getRowHeightVariable, isSameValueStringValue } from 'components/spreadsheet/helpers/functions'
import { cellStyles } from 'components/spreadsheet/components/cell/styles'

interface Props {
  value: boolean | null
  align: 'center' | 'left' | 'right'
  color: string
  readOnly: boolean
  rowHeight: number
  selected: boolean
  handleKeyDown: (event: React.KeyboardEvent) => void
  setCellValue: (value: string | null) => void
}

const styles = cellStyles()

const Checkbox: React.FC<Props> = ({
  value,
  align,
  color,
  readOnly,
  rowHeight,
  selected,
  handleKeyDown,
  setCellValue
}) => {
  const [currentValue, setCurrentValue] = useState<string>(
    value === undefined || value === null ? 'false' : value.toString()
  )

  useEffect(() => {
    if (!isSameValueStringValue(currentValue, value)) {
      setCurrentValue(value !== null && value !== undefined ? value.toString() : 'false')
    }
  }, [value])

  return (
    <div
      className={styles.value({ focused: selected, class: 'cell-value fit-text' })}
      data-focussed={selected || undefined}
      tabIndex={-1}
      style={{
        textAlign: align,
        color: color,
        width: 'var(--cell-width)',
        maxWidth: 'var(--cell-width)',
        maxHeight: `${getRowHeightVariable(rowHeight) - 2}px`
      }}
    >
      <input
        type="checkbox"
        checked={currentValue === 'true'}
        disabled={readOnly}
        onChange={(event) => {
          setCurrentValue(event.target.checked.toString())
          setCellValue(event.target.checked.toString())
        }}
        onKeyDown={handleKeyDown}
        className="h-5 w-5"
      />
    </div>
  )
}

export const CheckboxCell = Checkbox
